import React from 'react';
import _ from 'lodash';
import clsx from "clsx";
import {connect} from "react-redux";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import withStyles from "@material-ui/core/styles/withStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ClickAwayListener, Fade, Popper, Paper } from '@material-ui/core';

import {getBackToDivaCustomerLink} from "../../utils/constants";
import Link from "../Link";
import {
  getInvestmentDynamicPath,
  getRouteFullPathByComponent
} from "../../containers/InvestmentPlatform/utils";
import {getAuthSelector, getInvestmentPlatformSelector} from "../../utils/redaxSelectors";
import {windowOpenInternalLink} from "../../utils/utils";

import styles from "./styles";

const mapStateToProps = (state) => ({
  investmentPlatform: getInvestmentPlatformSelector(state),
  auth: getAuthSelector(state),
});

const CustomerFullnameMenu = props => {

  const {
    classes,
    customer,
    customerFullname,
    additionalLinks,
    investmentPlatform,
    auth: {
      user
    }
  } = props;

  if (!customer || !_.get(user, 'is_broker')) {
    return <div>{customerFullname}</div>
  }

  const defaultLinks = React.useMemo(() => [
    {title: 'Formularcenter', component: 'FORM_CENTER', icon: ['fa', 'file-invoice']},
    {title: 'Kundendaten', component: 'CRM', icon: ['far', 'user']},
    {title: 'Risikoklassenanalyse', component: 'RISK_INDICATOR_OVERVIEW', disabled: !_.get(customer, 'last_srri.srri'), icon: ['fa', 'user-chart']},
    {title: 'Transaktionsübersicht', component: 'TRANSACTIONS_OVERVIEW', icon: ['fa', 'exchange']},
    {title: 'Vermögensübersicht', component: 'DASHBOARD', icon: ['fa', 'analytics']}
  ], [customer]);

  const [customerDropdownOpened, setCustomerDropdownOpened] = React.useState(false);
  const customerID = customer.customer_id;
  const customerRef = React.useRef();
  const [arrowRef, setArrowRef] = React.useState(null);

  const handleClick = () => {
    setCustomerDropdownOpened(!customerDropdownOpened)
  };

  const handleClose = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (customerDropdownOpened) {
      setCustomerDropdownOpened(false);
    }
  };

  const renderMenuLink = (link, handleOnLinkClick) => (
    <Link
      key={link.component}
      className={clsx(classes.dropdownItem, link.disabled ? classes.dropdownItemDisabled : '')}
      title={link.title}
      disabled={link.disabled}
      icon={link.icon && <FontAwesomeIcon icon={link.icon} fixedWidth={true}/>}
      onClick={handleOnLinkClick}
    />
  );

  const menuLinks = React.useMemo(() => _.sortBy([...defaultLinks, ...(additionalLinks || [])], 'title').map(link => {
    if (link.component === 'CRM') {
      return renderMenuLink(link, () => window.open(getBackToDivaCustomerLink(customerID), '_blank'))
    }

    const path = getRouteFullPathByComponent(investmentPlatform.routes, link.component, ':customer_id');
    return renderMenuLink(link,() => windowOpenInternalLink( `/${getInvestmentDynamicPath()}${path.replace(':customer_id', customerID)}`, '_blank'))
  }), [defaultLinks, additionalLinks, customerID, investmentPlatform.routes]);

  return (
    <div className={classes.dropdownMenuWrapper} ref={customerRef}>
      <Link
        title={
          <span className={classes.linkTitleContainer}>
            <span className={classes.linkContent}>
              {customerFullname}
              <span className={classes.linkIcon}>
                <ExpandMoreIcon />
              </span>
            </span>
          </span>
        }
        onClick={handleClick}
      />
      <Popper
        open={customerDropdownOpened}
        anchorEl={customerRef.current}
        placement="bottom"
        transition
        className={classes.popper}
        modifiers={{
          offset: {enabled: true, offset: '0, 10'},
          arrow: {enabled: true, element: arrowRef},
        }}
        onClick={(event) => event.stopPropagation()}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Fade {...TransitionProps}>
              <Paper classes={{root: classes.dropdownMenu}}>
                {menuLinks}
                <span className={classes.arrow} ref={setArrowRef} />
              </Paper>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </div>
  );
};

export default connect(mapStateToProps)(withStyles(styles)(CustomerFullnameMenu));
